import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollFunc {
    constructor() {
        this.scrollTrigger = null;
        this.init();
    }

    init() {
        this._setScrollTrigger();
        this._addSmoothScroll();
        this._toPageTop();
    }

    _setScrollTrigger() {
        const $triggerArray = [...document.querySelectorAll('.js-scrollfunc')];

        $triggerArray.forEach(($trigger) => {
            this.scrollTrigger = ScrollTrigger.create({
                trigger: $trigger,
                start: 'top 80%',
                // markers: true,
                onEnter: () => $trigger.classList.add('-scrollin'),
            });
        });
    }

    _addSmoothScroll() {
        const $triggerArray = [...document.querySelectorAll('.js-smoothscroll')];

        $triggerArray.forEach(($trigger) => {
            $trigger.addEventListener('click', (e) => this._setSmoothScroll(e));
        });
    }

    _setSmoothScroll(e) {
        e.preventDefault();

        const y = e.currentTarget.hash || 0;
        const scrollTo = { y: y };

        gsap.to(window, { duration: 0.8, scrollTo: scrollTo, ease: 'expo.inOut' });
    }

    _toPageTop() {
        const $pagetop = [...document.querySelectorAll('.js-pagetop')];

        $pagetop.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                gsap.to(window, { duration: 1, scrollTo: { y: 0 }, ease: 'expo.inOut' });
            });
        });
    }
}
